"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var l10n_1 = require("@paprika/l10n");
var popover_1 = __importDefault(require("@paprika/popover"));
var constants_1 = require("../../constants");
var sc = __importStar(require("./CurrentApp.styles"));
var ThemeProvider_1 = require("../theme/ThemeProvider");
function CurrentApp(_a) {
    var appUrl = _a.appUrl, appId = _a.appId, appModuleName = _a.appModuleName, zIndex = _a.zIndex;
    var i18n = l10n_1.useI18n();
    var isTrainingOrg = ThemeProvider_1.useTheme().isTrainingOrg;
    var appName = i18n.t("global_navigation.apps." + appId, {
        defaultValue: appModuleName,
    });
    var dashboardLinkTitle = i18n.t('global_navigation.apps.dashboard', { module: appName });
    var currentAppName = isTrainingOrg ? i18n.t('global_navigation.training.app_name', { appName: appName }) : appName;
    return (react_1.default.createElement(sc.CurrentAppWrapper, { "data-sri-anchor": "navigation-current-app" },
        react_1.default.createElement(popover_1.default, { isEager: true, isDark: true, zIndex: zIndex },
            react_1.default.createElement(popover_1.default.Trigger, null, function (handler) { return (react_1.default.createElement(sc.CurrentAppAnchorTrigger, { "data-sri-anchor": isTrainingOrg ? "navigation-item.trigger.training" : "navigation-item.trigger", onMouseOver: handler, onMouseOut: handler, onBlur: handler, "aria-label": dashboardLinkTitle, href: appUrl }, currentAppName)); }),
            react_1.default.createElement(popover_1.default.Content, null,
                react_1.default.createElement(popover_1.default.Card, null, dashboardLinkTitle)),
            react_1.default.createElement(popover_1.default.Tip, null))));
}
CurrentApp.propTypes = {
    appUrl: prop_types_1.default.string,
    appId: prop_types_1.default.string,
    appModuleName: prop_types_1.default.string,
    zIndex: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
};
CurrentApp.defaultProps = {
    appUrl: '/',
    appId: '',
    appModuleName: null,
    zIndex: 9999,
};
CurrentApp.componentType = constants_1.navigationItems.currentApp;
exports.default = CurrentApp;
//# sourceMappingURL=CurrentApp.js.map